var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t("Login")))]),_c('span',[_vm._v(" "+_vm._s(_vm.$t("LoginInfo"))+" ")]),_c('sign-in-form',{attrs:{"formType":"jwt","email":"","password":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }